import React from 'react';
import { Link } from 'react-router-dom';
import translations from './translation.js';

const NotFound = () => {
  const currentLanguage = localStorage.getItem('selectedLanguage') || 'en';
  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>{translations[currentLanguage].not_found}</h1>
      <p style={styles.text}>{translations[currentLanguage].not_found_text}</p>
      <Link to="/feed">{translations[currentLanguage].go_back}</Link>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    textAlign: 'center',
    font: 'Bungee, FangSong, sans-serif',
  },
  heading: {
    fontSize: '3rem',
    marginBottom: '16px',
    color: 'white',
  },
  text: {
    fontSize: '1.5rem',
    color: 'white',
  },
};

export default NotFound;
